import { useMemo } from 'react';
import { BloomreachProductType } from '../../hooks/use-search';

export const filterOrder = [
    'category',
    'price',
    'brand',
    'cuisineType',
    'material',
    'color',
    'size',
    'rating',
    'saving',
] as const;

export type FilterType = (typeof filterOrder)[number];

const allowedFiltersByProductType: Record<BloomreachProductType, FilterType[]> = {
    [BloomreachProductType.hardgood]: [...filterOrder],
    [BloomreachProductType.recipe]: ['category', 'brand', 'cuisineType'],
    [BloomreachProductType.culinary]: ['category', 'brand'],
};

export const useFilter = (productType: BloomreachProductType): FilterType[] =>
    useMemo(() => allowedFiltersByProductType[productType] ?? filterOrder, [productType]);
